import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// @ts-ignore
import { makeSelectSubmitting } from 'shared';
// Global Selectors
import { makeSelectError } from 'services/error/selectors';

// Global Types
import { AppState } from 'services/types';
import { resetErrorByNamespace } from 'services/error/actions';

export interface OwnProps {
    namespace: string | string[];
}

interface ConnectedProps {
    isCreating?: boolean;
    errorMessage?: string | boolean;
}
interface DispatchProps {
    resetErrorByNamespace: typeof resetErrorByNamespace;
}

type Props = ConnectedProps & OwnProps & DispatchProps;

interface State {
    showSuccess: boolean;
    showError: boolean;
}

export class SaveMessageComponent extends React.PureComponent<Props, State> {
    state = {
        showSuccess: false,
        showError: false
    };

    timer: NodeJS.Timer | null = null;

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;

        if (!prevProps.isCreating && props.isCreating) {
            props.resetErrorByNamespace(props.namespace);
        } else if (prevProps.isCreating && !props.isCreating) {
            if (props.errorMessage) {
                this.triggerError();
            } else {
                this.triggerSuccess();
            }
        }
    }

    componentWillUnmount(): void {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    triggerSuccess = (): void => {
        this.setState({ showSuccess: true }, () => {
            this.triggerReset();
        });
    };

    triggerError = (): void => {
        this.setState({ showError: true }, () => {
            this.triggerReset();
        });
    };

    triggerReset = (): void => {
        this.timer = setTimeout(() => {
            this.setState({ showSuccess: false, showError: false });
        }, 5000);
    };

    render(): React.ReactElement | null {
        const { isCreating } = this.props;
        const { showSuccess, showError } = this.state;

        if (isCreating) {
            return <Message info>Uploading changes...</Message>;
        }

        if (showError) {
            return <Message error>There was an error</Message>;
        }

        if (showSuccess) {
            return <Message success>All changes uploaded</Message>;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isCreating: makeSelectSubmitting(),
    errorMessage: makeSelectError()
});

export default connect(mapStateToProps, { resetErrorByNamespace })(
    SaveMessageComponent
);
